export const setAuth = 'setAuth';
export const getToken = 'getToken';
export const getUser = 'getUser';

